<template>
  <v-container fluid class="px-0 py-0">
    <drawer-left>
      <template v-slot:left>
        <div>
          <div class="rule-info">
            <h3>{{ rule.name }}</h3>
            <p v-if="rule.desc" class="rule-desc">{{ rule.desc }}</p>
            <div class="rule-ext">
              <span v-if="rule.personType">适用人员类型:<em>{{ rule.personType }}</em></span>
              <span v-if="rule.vehicleType">适用业务类型:<em>{{ rule.vehicleType }}</em></span>
              <span v-if="rule.readJoinExam"><em class="primary--text">阅读参与考核</em></span>
            </div>
            <v-divider />
          </div>
          <v-card flat>
            <v-list subheader three-line v-if="rule.reqNum > 0">
              <v-subheader>必学</v-subheader>
              <v-list-tile :class="{ 'primary--text': selIndex == `rc_${idx}` }" v-for="(c, idx) in requires"
                :key="c.id" @click="onCourseware(c, `rc_${idx}`)">
                <v-list-tile-content>
                  <v-list-tile-title>{{ c.name || c.coursewareName }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ c.learnMode == 1 ? "顺序学习" : "随机学习" }}/{{
              c.scoreMode == 1 ? "按学时" : "按时长"
            }}计分</v-list-tile-sub-title>
                  <v-list-tile-sub-title>共{{
                c.scoreMode == 1
                  ? `${c.coursewareScore}学时`
                  : `${parseInt(c.coursewareDur / 60)}分钟`
              }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-list subheader three-line v-if="rule.optNum > 0">
              <v-subheader>选学</v-subheader>
              <v-list-tile :class="{ 'primary--text': selIndex == `oc_${idx}` }" v-for="(c, idx) in opts" :key="c.id"
                @click="onCourseware(c, `oc_${idx}`)">
                <v-list-tile-content>
                  <v-list-tile-title>{{ c.name || c.coursewareName }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ c.learnMode == 1 ? "顺序学习" : "随机学习" }}/{{
              c.scoreMode == 1 ? "按学时" : "按时长"
            }}计分</v-list-tile-sub-title>
                  <v-list-tile-sub-title>共{{
                c.scoreMode == 1
                  ? `${c.coursewareScore}学时`
                  : `${parseInt(c.coursewareDur / 60)}分钟`
              }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-list subheader two-line v-if="rule.quizNum > 0">
              <v-subheader>考试</v-subheader>
              <v-list-tile :class="{ 'primary--text': selIndex == `p_${idx}` }" v-for="(c, idx) in papers" :key="c.id"
                @click="onPaper(c, `p_${idx}`)">
                <v-list-tile-content>
                  <v-list-tile-title>{{ c.name || c.paperName }}</v-list-tile-title>

                  <v-list-tile-sub-title>{{
              c.type == 1 ? `考试` : `练习`
            }}</v-list-tile-sub-title>

                  <v-list-tile-sub-title v-if="c.type == 1">
                    {{ c.tryCount > 0 ? `最多考${c.tryCount}次` : "随时考" }}/{{
              c.passScore > 0 ? `${c.passScore}分通过` : `无通过分`
            }}
                  </v-list-tile-sub-title>

                  <v-list-tile-sub-title v-if="c.type == 2">
                    {{ `要求完成${c.passScore}道题` }}
                  </v-list-tile-sub-title>

                  <v-list-tile-sub-title v-if="c.duration">
                    {{ `考试时间${c.duration}分钟` }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </div>
      </template>
      <template v-slot:right>
        <h2 class="primary--text">{{ title }}</h2>
        <v-divider class="my-2" />
        <component :show-title="false" :is="componentName" :cfg="componentCfg" />
      </template>
    </drawer-left>
  </v-container>
</template>

<script>
import { DrawerLeft } from "javaee-fre";
export default {
  name: "clazzrule-view",
  props: {
    cfg: Object,
  },
  components: {
    "drawer-left": DrawerLeft,
  },
  data() {
    return {
      rule: {},
      requires: [],
      opts: [],
      papers: [],
      componentName: "",
      componentCfg: {},
      title: "",
      selIndex: "",
    };
  },
  watch: {
    cfg() {
      this.init();
    },
  },
  methods: {
    onCourseware(c, idx) {
      this.selIndex = idx;
      this.componentCfg = { targetId: c.coursewareId };
      this.componentName = "courseware-view";
      this.title = c.name || c.coursewareName;
    },
    onPaper(c, idx) {
      this.selIndex = idx;
      this.componentCfg = { id: c.paperId };
      this.componentName = "paper-view";
      this.title = c.name || c.paperName;
    },
    init() {
      let self = this,
        cfg = self.cfg;
      if (cfg && cfg.targetId) {
        self.$axios.get(`/home/my/crule/detail/${cfg.targetId}`).then((r) => {
          if (r.data && r.data.status == "ok") {
            let d = r.data,
              rule = d.message,
              requires = [],
              opts = [];
            if (d.coursewares) {
              for (let i in d.coursewares) {
                let c = d.coursewares[i];
                if (c.optional) {
                  opts.push(c);
                } else {
                  requires.push(c);
                }
              }
            }

            self.requires = requires;
            self.opts = opts;
            self.papers = d.papers;
            self.rule = rule;

            if (requires.length > 0) {
              self.onCourseware(requires[0], "rc_0");
            } else if (opts.length > 0) {
              self.onCourseware(opts[0], "oc_0");
            } else if (d.papers.length > 0) {
              self.onPaper(d.papers[0], "p_0");
            }
          }
        });
      }
    },
  },
  created() {
    this.init();
  },
};
</script>

<style scoped>
.rule-info .rule-desc {
  color: #888;
  margin: 8px 0;
  padding: 0;
}

.rule-info .rule-ext span {
  margin-right: 8px;
  color: #888;
}

.rule-info .v-divider {
  margin: 8px 0;
}
</style>
